export default "__VITE_PUBLIC_ASSET__4a374796__"